export default __webpack_public_path__ + "static/media/1.2eaed00f.jpg";